import { PageRef } from 'providers/page-ref';

export enum BarcodeScannerTab {
  Scan = 'scan',
  EnterManually = 'enterManually'
}

export type BarcodeScannerPageParams = {
  gotoFoodsAfterScan_dayDate?: string;
  returnCallback?: string;
  local?: {
    returnContext?: unknown;
  };
};

export type BarcodeScannerPageResult = string; // the scanned barcode

export const IBarcodeScannerPage: PageRef<BarcodeScannerPageParams, BarcodeScannerPageResult> = {
  pageName: 'BarcodeScannerPage',
} as PageRef<BarcodeScannerPageParams, BarcodeScannerPageResult>;
